import { Api } from "./Api";
import { enviroments } from "../enviroments/enviroments.dev";
import { env } from "../config/config";
import { loadSession } from "../utils/session";
import axios from "axios";

export class AuthService {

    public static async makeUserLogin (nickname:string, password:string) {

        const response = await axios.post(
            `${enviroments.auth}/login`,
            { login: nickname, password,}
        );

        return response.data;

    }

    // Registro publico de pessoa fisica. Retorna a mesma sessao do /login
    // (accessToken + dados do usuario). O backend so aceita name/email/password.
    public static async registerUser (name:string, email:string, password:string) {

        const response = await axios.post(
            `${enviroments.auth}/register/user`,
            { name, email, password }
        );

        return response.data;

    }

    // Registro publico de empresa. O backend exige o payload aninhado
    // { company: {name, cnpj?}, owner: {name, email, password} } e ja devolve
    // uma sessao logada (accessToken), igual ao /login.
    public static async registerCompany (
        companyName: string,
        owner: { name: string; email: string; password: string },
        cnpj?: string,
    ) {
        const response = await axios.post(
            `${enviroments.auth}/register/company`,
            {
                company: { name: companyName, ...(cnpj ? { cnpj } : {}) },
                owner:   { name: owner.name, email: owner.email, password: owner.password },
            }
        );

        return response.data;

    }

    public static async makePriceApiLogin () {
        const responese = await axios.post(
            `${env.config.priceUrl}/rate/usdbrl/auth/login`,
            {
                "username": "admin",
                "password": "h8C1TVdD6wCWpu0uRriS0b6PLPiUIpN4"
            }
        )
        return responese.data;
    }

    // Troca da propria senha. O alvo e o dono do token — o backend nao aceita
    // id no corpo de proposito.
    public static async changePassword (currentPassword: string, newPassword: string) {
        const token = loadSession<{ accessToken?: string }>()?.accessToken;
        const response = await axios.patch(
            `${enviroments.auth}/password`,
            { currentPassword, newPassword },
            { headers: { Authorization: `Bearer ${token}` } },
        );
        return response.data;
    }

    public static async verifyToken () {
        try {
            // /auth/verify exige JWT — envia o token da sessao no header.
            const token = loadSession<{ accessToken?: string }>()?.accessToken;
            if (!token) return undefined;
            const response = await axios.get(`${enviroments.auth}/verify`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (e) {
            return undefined;
        }
    }

    public static async getPrice(bearer: string) {
        const response = await axios.get(`${env.config.priceUrl}/rate/usdbrl/quotes/usdbrl`, {
            headers: {
            Authorization: `Bearer ${bearer}`,
            },
        });

        return response.data;
    }
}